import type { ApiResponse, PaginatedResponse, PaginationParams } from '@froma/shared';

export const API_BASE = '/api';
const TOKEN_KEY = 'froma_auth_token';

let token: string | null = typeof window !== 'undefined' ? localStorage.getItem(TOKEN_KEY) : null;

export function setToken(newToken: string | null) {
  token = newToken;
  if (typeof window !== 'undefined') {
    if (newToken) {
      localStorage.setItem(TOKEN_KEY, newToken);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  }
}

export async function request<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...((options.headers as Record<string, string>) || {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers,
    credentials: 'include',
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Request failed' })) as { error?: string | { message?: string } };
    const errorMessage = typeof errorData.error === 'object'
      ? errorData.error?.message || 'Request failed'
      : errorData.error || `HTTP ${response.status}`;
    throw new Error(errorMessage);
  }

  return response.json();
}

export function getToken() {
  return token;
}

export type { ApiResponse, PaginatedResponse, PaginationParams };
